import { useMemo } from 'react';

import { useStores } from '../../../stores/useStores';
import type { CoinBackWidgetDataType, WidgetEntry } from '../types';

export function useCoinBackWidgets() {
  const { coinBackStore } = useStores();

  const { currentCoinBack, currentCoinBackBooster, isTutorialOpen: isCoinBackTutorialOpen } = coinBackStore;
  const { showWidget: showCoinBackWidget = false } = currentCoinBack ?? {};

  const coinBackWidgets: CoinBackWidgetDataType[] = useMemo(() => {
    const showCoinBack = Boolean(
      currentCoinBack && (showCoinBackWidget || isCoinBackTutorialOpen || currentCoinBackBooster),
    );
    if (!showCoinBack || !currentCoinBack) {
      return [];
    }
    return [
      {
        key: 'coinback',
        event: currentCoinBack,
        dataTestId: 'coinback-widget',
      },
    ];
  }, [currentCoinBack, currentCoinBackBooster, isCoinBackTutorialOpen, showCoinBackWidget]);

  return useMemo(
    () => coinBackWidgets.map((data): WidgetEntry<'coinBack'> => ({ data, type: 'coinBack', id: data.key })),
    [coinBackWidgets],
  );
}
